import React from 'react';
import { getValidationError } from '../../functions/common';
const ValidationMessage = React.memo((props) => {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: `${(_a = props.resetClasses) !== null && _a !== void 0 ? _a : "text-red-500 text-xs italic ml-2 h-2.5 sm:-bottom-3 -sm:bottom-1"}` }, getValidationError(props.name, props.validationErrors))));
});
export default ValidationMessage;
